import { fetchBaseQueryWrapper } from "@/services/helpers";
import { createApi } from "@reduxjs/toolkit/dist/query/react";

const DOCUMENT_TAG_TYPE = "Document";

const handleDocumentTag = (result, error, projectId) => [
  { type: DOCUMENT_TAG_TYPE, projectId },
];

export const projectMilestoneDocumentApi = createApi({
  reducerPath: "projectMilestoneDocumentApi",
  baseQuery: fetchBaseQueryWrapper({
    path: "projectMilestoneDocuments",
  }),
  tagTypes: [DOCUMENT_TAG_TYPE],
  endpoints: (build) => ({
    uploadProjectMilestoneDocument: build.mutation({
      query: ({ uploadRequest, projectId, milestoneId }) => ({
        url: `${projectId}/${milestoneId}`,
        method: "POST",
        body: uploadRequest,
      }),
      invalidateTags: handleDocumentTag,
    }),
    getAllProjectMilestoneDocuments: build.query({
      query: (projectId) => `${projectId}`,
      transformResponse: ({ data }) => data,
      providesTags: handleDocumentTag,
    }),
    getDocumentsForMilestone: build.query({
      query: ({ projectId, milestoneId }) =>
        `${projectId}/${milestoneId}`,
      transformResponse: ({ data }) => data,
      providesTags: handleDocumentTag,
    }),

    removeProjectMilestoneDocument: build.mutation({
      query: ({ projectId, documentId }) => ({
        url: `${projectId}/${documentId}`,
        method: "DELETE",
      }),
      invalidateTags: handleDocumentTag,
    }),
  }),
});

export const {
  useUploadProjectMilestoneDocumentMutation,
  useGetAllProjectMilestoneDocumentsQuery,
  useGetDocumentsForMilestoneQuery,
  useRemoveProjectMilestoneDocumentMutation,
} = projectMilestoneDocumentApi;
